// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-header {
  height: var(--header-height);
  background-color: var(--glass-bg);
  backdrop-filter: var(--glass-blur);
  border-bottom: 1px solid var(--glass-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  flex-shrink: 0;
  z-index: 100;
  box-shadow: var(--shadow-sm);
  position: relative;
}

/* Header Shine */
.chat-header::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.05), transparent);
}

.chat-header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
  min-width: 0;
}

.channel-info-pill {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: rgba(255, 255, 255, 0.03);
  padding: 8px 18px;
  border-radius: 12px;
  border: 1px solid var(--glass-border);
  transition: all var(--transition-normal);
  cursor: pointer;
}

.channel-info-pill:hover {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: var(--brand-primary);
  transform: translateY(-1px);
}

.channel-icon {
  color: var(--brand-primary);
  filter: drop-shadow(0 0 5px rgba(153, 27, 27, 0.4));
  flex-shrink: 0;
}

.channel-name {
  font-size: 16px;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.channel-description {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0.6;
  display: flex;
  align-items: center;
}

/* Mini Status Dot */
.status-dot-mini {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 3px;
  margin-right: 6px;
  flex-shrink: 0;
}

.status-dot-mini.online { background-color: var(--status-online); }
.status-dot-mini.idle { background-color: var(--status-idle); }
.status-dot-mini.dnd { background-color: var(--status-dnd); }
.status-dot-mini.offline { background-color: var(--status-offline); }

.chat-header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.header-actions, .header-tools {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-icon-button {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  transition: all var(--transition-normal);
}

.header-icon-button:hover {
  color: var(--text-primary);
  background-color: var(--bg-modifier-hover);
  transform: translateY(-2px);
}

.header-icon-button svg {
  transition: transform var(--transition-fast);
}

.header-icon-button:hover svg {
  transform: scale(1.1);
}

/* Premium Search Bar */
.global-search {
  position: relative;
  display: flex;
  align-items: center;
}

.global-search input {
  width: 260px;
  background-color: var(--bg-tertiary);
  border: 1px solid var(--glass-border);
  border-radius: 12px;
  padding: 10px 16px 10px 40px;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
  outline: none;
  transition: all var(--transition-normal);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.global-search input:focus {
  width: 360px;
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 4px rgba(153, 27, 27, 0.1), var(--shadow-md);
  background-color: var(--bg-secondary);
}

.global-search .search-icon {
  position: absolute;
  left: 14px;
  color: var(--text-muted);
  pointer-events: none;
  transition: color var(--transition-fast);
}

.global-search input:focus + .search-icon {
  color: var(--brand-primary);
}

.global-search input:focus ~ .search-filter-toggle {
  opacity: 0;
  pointer-events: none;
}

.search-filter-toggle {
  position: absolute;
  right: 12px;
  background-color: var(--bg-primary);
  border: 1px solid var(--glass-border);
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s;
  z-index: 5;
}

.search-filter-toggle:hover {
  background-color: var(--bg-modifier-hover);
  color: var(--text-primary);
  border-color: var(--brand-primary);
}

.search-filter-toggle.active {
  background-color: var(--brand-primary);
  color: white;
  border-color: var(--brand-primary);
  box-shadow: 0 0 10px rgba(153, 27, 27, 0.4);
}

.help-btn:hover {
  color: white;
  background-color: var(--info);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none;
  background: transparent;
  border: none;
  color: var(--text-muted, #94a3b8);
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.mobile-menu-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
}

@media (max-width: 768px) {
  .mobile-menu-btn {
    display: inline-flex;
  }
  .chat-header {
    padding: 0 12px;
  }
  .chat-header-left {
    gap: 8px;
  }
  .channel-info-pill {
    padding: 6px 10px;
    gap: 6px;
  }
  .channel-description {
    display: none;
  }
  .header-tools {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatHeader/ChatHeader.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,kCAAkC;EAClC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B,sCAAsC,EAAE;AAClE,wBAAwB,oCAAoC,EAAE;AAC9D,uBAAuB,mCAAmC,EAAE;AAC5D,2BAA2B,uCAAuC,EAAE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,8DAA8D;EAC9D,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".chat-header {\n  height: var(--header-height);\n  background-color: var(--glass-bg);\n  backdrop-filter: var(--glass-blur);\n  border-bottom: 1px solid var(--glass-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 28px;\n  flex-shrink: 0;\n  z-index: 100;\n  box-shadow: var(--shadow-sm);\n  position: relative;\n}\n\n/* Header Shine */\n.chat-header::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.05), transparent);\n}\n\n.chat-header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex: 1;\n  min-width: 0;\n}\n\n.channel-info-pill {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background-color: rgba(255, 255, 255, 0.03);\n  padding: 8px 18px;\n  border-radius: 12px;\n  border: 1px solid var(--glass-border);\n  transition: all var(--transition-normal);\n  cursor: pointer;\n}\n\n.channel-info-pill:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-color: var(--brand-primary);\n  transform: translateY(-1px);\n}\n\n.channel-icon {\n  color: var(--brand-primary);\n  filter: drop-shadow(0 0 5px rgba(153, 27, 27, 0.4));\n  flex-shrink: 0;\n}\n\n.channel-name {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.channel-description {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  opacity: 0.6;\n  display: flex;\n  align-items: center;\n}\n\n/* Mini Status Dot */\n.status-dot-mini {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  margin-right: 6px;\n  flex-shrink: 0;\n}\n\n.status-dot-mini.online { background-color: var(--status-online); }\n.status-dot-mini.idle { background-color: var(--status-idle); }\n.status-dot-mini.dnd { background-color: var(--status-dnd); }\n.status-dot-mini.offline { background-color: var(--status-offline); }\n\n.chat-header-right {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.header-actions, .header-tools {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.header-icon-button {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  transition: all var(--transition-normal);\n}\n\n.header-icon-button:hover {\n  color: var(--text-primary);\n  background-color: var(--bg-modifier-hover);\n  transform: translateY(-2px);\n}\n\n.header-icon-button svg {\n  transition: transform var(--transition-fast);\n}\n\n.header-icon-button:hover svg {\n  transform: scale(1.1);\n}\n\n/* Premium Search Bar */\n.global-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.global-search input {\n  width: 260px;\n  background-color: var(--bg-tertiary);\n  border: 1px solid var(--glass-border);\n  border-radius: 12px;\n  padding: 10px 16px 10px 40px;\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 600;\n  outline: none;\n  transition: all var(--transition-normal);\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.global-search input:focus {\n  width: 360px;\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 4px rgba(153, 27, 27, 0.1), var(--shadow-md);\n  background-color: var(--bg-secondary);\n}\n\n.global-search .search-icon {\n  position: absolute;\n  left: 14px;\n  color: var(--text-muted);\n  pointer-events: none;\n  transition: color var(--transition-fast);\n}\n\n.global-search input:focus + .search-icon {\n  color: var(--brand-primary);\n}\n\n.global-search input:focus ~ .search-filter-toggle {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.search-filter-toggle {\n  position: absolute;\n  right: 12px;\n  background-color: var(--bg-primary);\n  border: 1px solid var(--glass-border);\n  border-radius: 6px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.2s;\n  z-index: 5;\n}\n\n.search-filter-toggle:hover {\n  background-color: var(--bg-modifier-hover);\n  color: var(--text-primary);\n  border-color: var(--brand-primary);\n}\n\n.search-filter-toggle.active {\n  background-color: var(--brand-primary);\n  color: white;\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 10px rgba(153, 27, 27, 0.4);\n}\n\n.help-btn:hover {\n  color: white;\n  background-color: var(--info);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* Mobile Menu Button */\n.mobile-menu-btn {\n  display: none;\n  background: transparent;\n  border: none;\n  color: var(--text-muted, #94a3b8);\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.mobile-menu-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n}\n\n@media (max-width: 768px) {\n  .mobile-menu-btn {\n    display: inline-flex;\n  }\n  .chat-header {\n    padding: 0 12px;\n  }\n  .chat-header-left {\n    gap: 8px;\n  }\n  .channel-info-pill {\n    padding: 6px 10px;\n    gap: 6px;\n  }\n  .channel-description {\n    display: none;\n  }\n  .header-tools {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
